import React from 'react'
import PropTypes from 'prop-types'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo })
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary] Caught error:', error, errorInfo)
  }

  render() {
    const { hasError, error, errorInfo } = this.state
    const { children, name } = this.props

    if (hasError) {
      return (
        <div style={{
          padding: 20,
          margin: 10,
          background: '#fff3f3',
          border: '2px solid #ff4444',
          borderRadius: 8,
          fontFamily: 'monospace',
          fontSize: 12,
          overflow: 'auto',
          maxHeight: '100vh',
        }}
        >
          <h2 style={{ color: '#cc0000', margin: '0 0 10px' }}>
            {`🐛 Crash in <${name || 'Component'}>`}
          </h2>
          <div style={{ marginBottom: 10 }}>
            <strong style={{ color: '#cc0000' }}>Error:</strong>
            <pre style={{
              background: '#1e1e1e',
              color: '#f44',
              padding: 10,
              borderRadius: 4,
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
            }}
            >
              {error && error.toString()}
            </pre>
          </div>
          {errorInfo && (
            <div>
              <strong>Component Stack:</strong>
              <pre style={{
                background: '#1e1e1e',
                color: '#4fc3f7',
                padding: 10,
                borderRadius: 4,
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                maxHeight: 300,
                overflow: 'auto',
              }}
              >
                {errorInfo.componentStack}
              </pre>
            </div>
          )}
          {error && error.stack && (
            <div style={{ marginTop: 10 }}>
              <strong>Stack Trace:</strong>
              <pre style={{
                background: '#1e1e1e',
                color: '#a5d6a7',
                padding: 10,
                borderRadius: 4,
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                maxHeight: 300,
                overflow: 'auto',
              }}
              >
                {error.stack}
              </pre>
            </div>
          )}
          <button
            type="button"
            onClick={() => this.setState({ hasError: false, error: null, errorInfo: null })}
            style={{
              marginTop: 12,
              padding: '8px 16px',
              background: '#cc0000',
              color: '#fff',
              border: 'none',
              borderRadius: 4,
              cursor: 'pointer',
              fontSize: 14,
            }}
          >
            Try Again
          </button>
        </div>
      )
    }

    return children
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  name: PropTypes.string,
}

ErrorBoundary.defaultProps = {
  name: 'Unknown',
}

ErrorBoundary.displayName = 'ErrorBoundary'

export default ErrorBoundary
